<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="commonFormStyles clueRegistration">
            <van-nav-bar
                title="线索登记"
                left-text="应用"
                left-arrow
                @click-left="onClickLeft"
            ></van-nav-bar>
            <section class="van-pull-refresh showFontBtn">
                <van-collapse v-model="activeNames">
                    <van-collapse-item name="1">
                        <div slot="title" class="title">
                            <i class="iconfont icondingdan"></i>基础信息
                        </div>
                        <van-cell
                            :value="clueData.clue_number"
                            title="线索编号"
                            :icon="require('@/assets/images/icons/icon_gy_1.png')"
                        ></van-cell>
                        <van-cell
                            :icon="require('@/assets/images/icons/icon_gy_7.png')"
                            title="登记时间"
                            :value="clueData.register_time"
                            default-date
                        >
                        </van-cell>
                        <van-cell
                            required
                            :icon="require('@/assets/images/icons/icon_3.png')"
                            title="客户名称"
                            :value="clueData.client_name"
                            @click="selectCompany()"
                            default-date
                            is-link
                        >
                        </van-cell>
                        <van-field
                            required
                            v-model="clueData.uniform_social_credit_code"
                            label="统一信用代码"
                            placeholder="请输入统一信用代码"
                            input-align="right"
                            :left-icon="require('@/assets/images/icons/icon_33.png')"
                        ></van-field>
                        <van-field
                            required
                            v-model="clueData.engineering_name"
                            label="工程名称"
                            placeholder="请输入工程名称(必填)"
                            input-align="right"
                            :left-icon="require('@/assets/images/icons/icon_2.png')"
                        ></van-field>
                        <van-cell
                            required
                            :icon="require('@/assets/images/icons/icon_gy_3.png')"
                            title="工程性质"
                            :value="clueData.engineering_property"
                            @click="selectProjectCategory()"
                            default-date
                            is-link
                        >
                        </van-cell>
                        <van-cell
                            :icon="require('@/assets/images/icons/icon_gy_2.png')"
                            title="工程位置"
                            :value="clueData.engineering_location"
                            @click="openProjecLocation"
                            default-date
                            is-link
                        >
                        </van-cell>
                    </van-collapse-item>
                    <van-collapse-item name="2">
                        <div slot="title" class="title">
                            <i class="iconfont iconlianxiren"></i>联系人信息
                        </div>
                        <van-field
                            required
                            v-model="clueData.client_contact_name"
                            label="客户联系人"
                            placeholder="请输入客户联系人名称（必填）"
                            input-align="right"
                            :left-icon="require('@/assets/images/icons/icon_3.png')"
                        ></van-field>
                        <van-field
                            required
                            v-model="clueData.client_contact_phone"
                            label="联系电话"
                            placeholder="请输入联系电话（必填）"
                            input-align="right"
                            :left-icon="require('@/assets/images/icons/icon_4.png')"
                        ></van-field>
                        <van-field
                            v-model="clueData.salesman_phone"
                            label="业务员电话"
                            placeholder="请输入业务员电话"
                            input-align="right"
                            :left-icon="require('@/assets/images/icons/icon_4.png')"
                        ></van-field>
                        <van-field
                            label="备注信息"
                            v-model="clueData.remarks"
                            rows="4"
                            autosize
                            type="textarea"
                            maxlength="80"
                            class="iconfont iconbeizhu textarea"
                            placeholder="请在此处输入备注信息"
                        ></van-field>
                    </van-collapse-item>
                </van-collapse>
            </section>
            <footer class="commonFormBtns">
                <van-button type="info" @click="gitClueRegistrationData">
                    保存
                </van-button>
            </footer>
        </div>
    </v-touch>
</template>

<script>

export default {
    // 线索登记
    name: 'clue-registration',
    components: {},
    beforeRouteLeave(to, from, next) {
        if (to.path === '/home') {
            this.$store.commit('noKeepAlive', 'clue-registration');
        }
        next();
    },
    props: {},
    data() {
        return {
            activeNames: ['1', '2'],
            // 线索登记绑定数据
            clueData: {
                ciid: '',
                // 线索编号
                clue_number: '',
                // 登记时间
                register_time: this.formatDate(),
                // 客户名称
                client_name: '',
                // 客户id
                client_id: '',
                // 统一社会信用代码
                uniform_social_credit_code: '',
                // 工程名称
                engineering_name: '',
                // 工程性质
                engineering_property: '',
                // 工程位置
                engineering_location: '',
                // X坐标
                x_coordinate_point: '',
                // Y坐标
                y_coordinate_point: '',
                // 客户联系人
                client_contact_name: '',
                // 客户联系电话
                client_contact_phone: '',
                // 业务员电话
                salesman_phone: '',
                // 线索跟踪结果
                clue_tracking_results: '',
                // 丢单原因
                lose_order_reason: '',
                // 备注
                remarks: '',
                // 关联线索池id
                clue_pool_id: '',
                // 是否app写入
                is_appin: true,
                // 线索编号索引
                auto_index: 0,
            },
        };
    },
    computed: {},
    watch: {},
    created() {
        // 判断路由中有没有参数，有参数的是选择后返回页面
        if (this.$route.query.data) {
            this.clueData = this.$route.query.data;
        }
    },
    mounted() {},
    destroyed() {},
    methods: {
        // 返回上级页面
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.replace({ path: '/home' });
        },
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.replace({ path: '/home' });
        },
        // 处理时间对象
        formatDate(date) {
            if (!date) {
                date = new Date();
            }
            const Y = date.getFullYear();
            const M = date.getMonth() + 1;
            const D = date.getDate();
            return Y + '-' + this.add0(M) + '-' + this.add0(D);
        },
        // 时间补0
        add0(m) {
            return m < 10 ? '0' + m : m;
        },

        // 选择公司
        selectCompany() {
            this.$router.isBack = 2;
            this.$router.push({
                name: 'selectCompany',
                params: {
                    title: '选择公司',
                    clueData: this.clueData,
                },
            });
        },
        // 选择工程类别
        selectProjectCategory() {
            this.$router.isBack = 2;
            this.$router.push({
                name: 'selectProjectCategory',
                params: {
                    title: '选择工程类别',
                    clueData: this.clueData,
                },
            });
        },
        // 打开工程位置页
        openProjecLocation() {
            this.$router.isBack = 2;
            this.$router.push({
                name: 'ProjectLocation',
                params: {
                    data: this.clueData,
                    type: '/clueRegistration',
                },
            });
        },
        // 生成线索编号
        async generateNumber() {
            await this.$axios
                .get('/interfaceApi/basicplatform/autocode/runtime?code=clue_code')
                .then(res => {
                    this.clueData.clue_number = res.AutoCodeValue;
                    this.clueData.auto_index = res.AutoIndex;
                    this.saveRequest();
                })
                .catch(error => {
                    this.$dialog({ message: error.ErrorCode.Message });
                });
        },
        // 保存
        gitClueRegistrationData() {
            // 生成线索编号
            this.generateNumber();
        },
        // 保存请求
        saveRequest() {
            this.$axios
                .post('/interfaceApi/sale/clue_manager/add_clue', this.clueData)
                .then(res => {
                    this.clueData.ciid = res;
                    this.$dialog({ message: '保存成功' });
                })
                .catch(error => {
                    this.$dialog({ message: error.ErrorCode.Message });
                });
        },
    },
};
</script>
<style lang="stylus">
.clueRegistration
    height 100%
    .van-icon
        .van-icon__image
            width 16rpx
            height 16rpx
            margin-top 3rpx
            margin-right 5rpx
    .van-collapse
        &:after
            display none
    .van-cell__title
        width 100rpx
        font-size 18rpx
        line-height 24rpx
        color #061F3E
        .iconfont
            font-size 18rpx
            margin-right 5rpx
    .van-collapse-item__content
        .van-cell__title
            font-size 16rpx
    .title
        font-size 17rpx
        color #3495FB
    .van-collapse-item__content
        padding 0
    .van-field__control,
    .van-cell__value
        color #979EA7
        &::placeholder
            color #D7D7D7 !important
</style>